module.exports = __webpack_public_path__ + "img/comp-table-interaction-resp-time-split.c0865b2c.png";